<template>
  <div class="dashboard-container">
    <v-container>
      <h1>HR dashboard</h1>
      <v-card outlined>
        <v-card-title style="margin-bottom: -2rem">
          <v-radio-group label="Order by : " v-model="orderBy" row @change="findDashboardData()">
            <v-radio label="First name" value="name"></v-radio>
            <v-radio label="number of reviews" value="number"></v-radio>
          </v-radio-group>
        </v-card-title>
          <div class="btn-groupe">
            <v-btn :disabled="loading" class="mr-2" @click="selectReviewsPart(true)">Part 1 & 2</v-btn>
            <v-btn :disabled="loading" @click="selectReviewsPart(false)">Part 3 & 4</v-btn>
          </div>
          <div class="ml-4 mt-4">
            <h4 >{{ title }}</h4>
          </div>
          <div class="center-container" v-if="loading">
              <v-progress-circular
                  indeterminate
                  color="green"
                  :size="80"
                  :width="5">
              </v-progress-circular>
          </div>
          <template v-if="dashboardData.length > 0">
              <Bar
                  :chart-options="chartOptions"
                  :chart-data="chartData"
                  :height="heightDashboard"/>

            <p class="ml-2" v-if="lastUpdate">
              Last update : {{ lastUpdate }}
            </p>
          </template>
          <template v-if="!dashboardData.length > 0 && !loading">
              <div class="center-container">
                <h3>No data found</h3>
              </div>
          </template>
      </v-card>
    </v-container>
  </div>
</template>
<style scoped>
.dashboard-container {
  margin-top: 130px;
  margin-left: 50px;
  margin-right: 50px;
}
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}
.btn-groupe {
  float:right;
  margin-right:1%;
  margin-top: 1%;
}
</style>

<script>
import {Bar} from "vue-chartjs/legacy";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip,} from "chart.js";
import axios from "axios";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
);

export default {
  name: "hrDashboard",
  components: { Bar },
  data() {
    return {
      orderBy: "name",
      lastUpdate: null,
      heightDashboard: 0,
      dashboardData: [],
      loading: true,
      title: "",
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
        },
        responsive: true,
        interaction: {
          intersect: false,
        },
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            ticks: {
              stepSize: 2,
              max: 101,
              min: 0,
              callback: function(value) {
                return value + " %";
              },
            },
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  },

  mounted: function() {
    this.findDashboardData();
  },

  methods: {
    findDashboardData() {
      const apiURL = `${process.env.VUE_APP_ROOT_API_PATH}api/reviews/dashboard/hrReferent?orderBy=${this.orderBy}`;
      const config = {
        headers: {'Content-Type': 'application/json'},
        withCredentials: true
      };
      axios.get(apiURL, config)
          .then(response => {
            this.dashboardData = response.data.data;

            if(this.dashboardData.length < 1) {
              this.loading = false;
              return;
            }

            const dateObject = new Date(response.data.data[0].lastUpdate);
            // Define the options for formatting
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            };
            this.lastUpdate = dateObject.toLocaleString('fr-FR', options);
            this.heightDashboard = this.dashboardData.length * 12;
            this.selectReviewsPart(true);
          })
          .catch(() => {
            this.message = "An error occurred, please try again later";
            this.messageType = "error";
            this.showMessage = true;
          });
    },

    selectReviewsPart: function(part) {
      if (part) {
        this.title = "Performance Review";
        this.chartData.labels = this.dashboardData.map(entry => `${entry.managerFirstName} ${entry.managerLastName} ${ '(' + entry.nbReviews + ')' }`);
        this.chartData.datasets = [
          {
            label: "Closed",
            backgroundColor: "#10AFA3",
            data: this.dashboardData.map(entry => (entry.nbReviewsFirstPartClosed / entry.nbReviews) * 100),
            scale: "step1",
          },
          {
            label: "At Employee Notification",
            backgroundColor: "#D1E0D7",
            data: this.dashboardData.map(entry => (entry.nbReviewsFirstPartEmpNotif/ entry.nbReviews) * 100),
            scale: "step1",
          },
          {
            label: "At Manager Proposal",
            backgroundColor: "#FFEEA3",
            data:  this.dashboardData.map(entry => (entry.nbReviewsFirstPartMan / entry.nbReviews)* 100),
            scale: "step1",
          },
          {
            label: "At Employee Proposal",
            backgroundColor: "#F8B121",
            data: this.dashboardData.map(entry => (entry.nbReviewsFirstPartEmpProp / entry.nbReviews) * 100),
            scale: "step1",
          },
        ];
      } else {
        this.title = "PDR Objectives Setting";
        this.chartData.labels = this.dashboardData.map(entry => `${entry.managedUser.firstName} ${entry.managedUser.lastName} ${ '(' + entry.nbReviews + ')' }`);
        this.chartData.datasets = [
          {
            label: "Closed",
            backgroundColor: "#10AFA3",
            data: this.dashboardData.map(entry => (entry.nbReviewsSecondPartClosed / entry.nbReviews) * 100),
            scale: "step1",
          },
          {
            label: "At Employee Notification",
            backgroundColor: "#D1E0D7",
            data: this.dashboardData.map(entry => (entry.nbReviewsSecondPartEmpNotif/ entry.nbReviews) * 100),
            scale: "step1",
          },
          {
            label: "At Manager Proposal",
            backgroundColor: "#FFEEA3",
            data:  this.dashboardData.map(entry => (entry.nbReviewsSecondPartMan / entry.nbReviews)* 100),
            scale: "step1",
          },
          {
            label: "At Employee Proposal",
            backgroundColor: "#F8B121",
            data: this.dashboardData.map(entry => (entry.nbReviewsSecondPartEmpProp / entry.nbReviews) * 100),
            scale: "step1",
          },
        ];
      }
      this.loading = false;
    },
  }
};
</script>
